import React, { useState, useEffect } from "react";
import "./viewOrders.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons";

import { useAuth } from "../../../contexts/AuthContext";
import { useOrder } from "../../../contexts/OrderContext";

import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../commonComponents/Loader/Loader";

export default function ViewOrders() {
  const [allOrders, setAllOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { currentUser, logout } = useAuth();
  const { dropZeros } = useOrder();
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://api.redfoxcafe.ir/v1/client/invoice/", {
      method: "GET",
      headers: {
        "Authorization-Token": "Bearer " + currentUser.access_token,
      },
    })
      .then((response) => response.json())
      .then((d) => {
        if (d.status === "200") {
          setIsLoading(false);
          if (Array.isArray(d.data)) {
            setAllOrders(d.data);
          } else return;
        } else if (d.status === "401") {
          toast.info(d.message);
          setIsLoading(false);
          logout();
          navigate("/login", { replace: true });
        } else {
          toast.error(d.message);
        }
      });
  }, []);

  const stringToDate = (dateStr) => {
    const months = [
      "Farvardin",
      "Ordibehesht",
      "Khordad",
      "Tir",
      "Mordad",
      "Shahrivar",
      "Mehr",
      "Aban",
      "Azar",
      "Dey",
      "Bahman",
      "Esfand",
    ];

    const dateArray = dateStr.split(",")[0].split(" ");
    dateArray[1] = months.indexOf(dateArray[1]) + 1;

    return dateArray.reverse().join("/");
  };

  const orders = allOrders.map((val) => (
    <div className="order-table-row order-table-data" key={val.InvoiceId}>
      <span>{stringToDate(val.InvoiceDateTime)}</span>
      <span>{dropZeros(val.InvoicePrice)} هزار تومان</span>
      <span>{val.InvoiceStatus}</span>
      <span className="detail-arrow">
        <Link to={`${val.InvoiceId}`}>
          <FontAwesomeIcon icon={faAngleDoubleLeft} />
        </Link>
      </span>
    </div>
  ));

  return isLoading ? (
    <Loader loading={isLoading} />
  ) : (
    <div className="orders-container custom-scroll">
      <div className="order-table-header order-table-row">
        <span>تاریخ سفارش</span>
        <span>مجموع پرداخت</span>
        <span>وضعیت</span>
        <span>جزئیات</span>
      </div>
      {orders}
    </div>
  );
}
